/**
 * Public API Surface of mdb5-adapted
 *
 * This file exports all public components, modules, services, and utilities
 * from the MDB5 Adapted library for Angular 15.
 */

// Core exports
export * from './core/compatibility/index';

// Re-export compatibility utilities for convenience
export { DestroyRefPolyfill } from './core/compatibility/destroy-ref.polyfill';
export { takeUntilDestroyed, takeUntilDestroyed$ } from './core/compatibility/take-until-destroyed.operator';

// Forms Components
export * from './components/forms/index';

// Core Components (Priority 1)
export * from './components/accordion/index';
export * from './components/modal/index';
export * from './components/dropdown/index';
export * from './components/datepicker/index';
export * from './components/select/index';
export * from './components/autocomplete/index';
export * from './components/table/index';

// UI Components (Priority 2)
export * from './components/carousel/index';
export * from './components/tabs/index';
export * from './components/tooltip/index';
export * from './components/popover/index';
export * from './components/collapse/index';
export * from './components/chips/index';
export * from './components/checkbox/index';
export * from './components/radio/index';

// Advanced Components (Priority 3)
export * from './components/lightbox/index';
export * from './components/loading/index';
export * from './components/rating/index';
export * from './components/sidenav/index';
export * from './components/stepper/index';
export * from './components/scrollspy/index';
export * from './components/range/index';
export * from './components/timepicker/index';

// Utilities (Priority 4)
export * from './components/ripple/index';
export * from './components/validation/index';
export * from './components/lazy-loading/index';
export * from './components/infinite-scroll/index';
export * from './components/animations/index';
export * from './components/charts/index';

// Basic UI Elements
export * from './components/button/index';
export * from './components/icon/index';
export * from './components/toolbar/index';

// Additional Utilities
export * from './components/option/index';
export * from './components/scrollbar/index';
export * from './components/notification/index';
export * from './components/popconfirm/index';
export * from './components/smooth-scroll/index';
export * from './components/sticky/index';

// Main module export
export * from './mdb5-adapted.module';
